export default __webpack_public_path__ + "static/media/RizadaMetalizada.c6b405f5.png";